export const TRIAL_MAPPING: Record<number, string> = {
    1: '491e27f0-6c3e-4d8e-962a-8d44ffbb79bc',
    2: '3485ee05-ee5b-4a49-84df-b932680a5935',
    3: 'b55f04d7-1fa1-43f5-82f5-e8c2390da11b',
    4: '6ddf9798-46b6-4289-b71a-2622c8540df9',
    5: 'c97af766-3b1e-4949-8cb8-9c18d45f2a46',
    6: '4ad60af2-31be-4862-a687-e2f6333adffb',
    7: '1052e895-4a60-44c0-a7c3-8061e44b36c4',
    8: '11a1af5d-7d7a-491c-9128-d034103e0cb9',
    9: '7fe4f13d-43ba-4496-9e21-37e0630b86cd',
    10: 'd52bd19f-2e0f-48c3-83d3-3824f2bd7c18',
    11: '92b17477-19ec-48f9-8758-c80faa15fda3',
    12: 'bdcc728a-6e89-4a92-a11f-0df40a32765b',
    13: '836d6d4e-0fec-4ced-a11e-39d27dae004a',
    14: 'f0718e2d-b634-4dce-a298-88d13996c7d1',
    15: '6334ad0f-bb64-4d7a-8678-9c663a93506f',
    16: '0db30412-9e96-4991-af7d-df94e929d11a',
    17: 'e8f7b29b-b473-4893-8a67-d87b2a00e884',
    18: 'f5f55909-03b7-45c0-b205-d86444a0c530',
    19: '0753e5ca-eb56-4cf3-a74a-d0691488b0fd',
    20: '54095f0d-3979-4176-9b76-4fa17d74d05f',
    21: '6bdee422-2b0d-4d87-980f-7c7922593957',
    22: 'f8205eb1-e217-45b6-a233-45ac944ff93a',
    23: '0d6b5813-c049-4971-b689-c04813e70e75',
    24: 'dd2c0572-9cac-4c9a-89c1-2f1bbe57940b',
    25: 'e1c25458-0412-4faf-aada-a17fde216ab2',
    26: '9bde5bc9-c3f5-4fa5-b217-38e212c683a5',
    27: 'b924b6f7-0130-4186-9159-a2517312f449',
    28: 'a5229944-51a4-4646-b571-efbd39758f60',
    29: 'f10e736e-0a7a-4354-ba76-608e5d33ccdd',
    30: '43fad8e4-20fd-43bc-8038-5365015fc122',
    31: '619c1ab6-0306-48b5-91e8-aa694fe25f87',
    32: 'c43ccabc-d765-4027-a987-808343199b7e',
    33: '831e03a0-b647-4b09-9691-5f61652c5a95',
    34: 'aaa664bb-c21f-4014-a798-6aebc22c0ba5',
    35: '16bd28e8-9df6-4224-a143-f42d36b67faa',
    36: 'b6630840-27bf-4187-955e-7f4a3693cd11',
    37: '6f96b524-aff6-4096-87a8-78222c35e9d8',
    38: 'f78c8f86-2b6d-4882-8e03-3903e20ec4f2',
    39: '498deb30-8af9-4922-b686-4ef5dc1dd4b6',
    40: 'ec73bf0b-171d-498b-a68e-e808534b51fe',
    41: 'f84467c5-64ba-4f5a-8b09-70f2296ebbaf',
    42: '20060052-f2a1-4876-995c-f8dcd6abe434',
    43: 'f3609521-f1b7-45e6-8c36-11931795dc74',
    44: '0cd14abb-77d6-4324-a213-dd9f5d08d289',
    45: '515a4c12-99b7-44d6-a0ef-d8232c6981d8',
    46: '8287a1a0-874b-47d0-be32-01f079215ce4',
    47: '2869449c-25dd-44ab-85ba-1efa66a6c135',
    48: 'cbd5c9d3-0803-466c-aeff-7656b520fc8f',
    49: '5f749382-4f6d-4c47-a972-8fea8084711d',
    50: 'a9d4a299-8d02-42d4-b68e-589c96276281',
    51: '285d3625-632f-4b32-9627-4627b4161dbf',
    52: '599dad86-de8f-48a7-b03d-a7819c5ebda1',
    53: '28265f13-b09f-4218-8e64-20e1160d7cee',
    54: 'f8c2e5bf-8aba-45c8-bb9b-c79800077e30',
    55: '1c6c6b80-3dcb-4fb3-873e-214d4a9b0b0d',
    56: 'ac4c1f8a-3ca5-442b-9d56-a62039601971',
    57: 'e0cfe46e-145c-42e0-8688-0919ff17634e',
    58: 'd80a1726-b718-4f59-a3b6-30c2be913dfd',
    59: '0e1b026a-2c91-4056-aef2-e0cf10813653',
    60: '6b76587a-fa1b-4242-b106-d8d2c6c8ef51',
    61: 'f01c335f-320f-4c9e-b897-81d8516842dc',
    62: 'b6dec2f2-de9c-4527-851f-98ba7eb296cf',
    63: 'f571c863-2d72-4a60-8e95-e4a1cec76933',
    64: 'fe297c19-a2cf-49c7-b4f6-c1069454cf7c',
    65: '2e5efb4d-b2cc-4e54-8e8c-27da62ef6f8b',
    66: '309c76f0-e2b6-4a82-b572-baf7acd32351',
    67: 'e850a82d-6d7b-4425-b293-1ab353a3cfe0',
    68: '7a26c178-227b-4b75-82f7-0bd34c09bc04',
    69: '65d8db2d-3e81-40be-a0c8-bba2195f730b',
    70: 'c4b0ab94-6fd9-4749-8c72-40a827778ab3',
    71: '147dc810-f7bd-4fc7-99bc-c560e9fbb211',
    72: 'd14405bd-cf3e-42c9-b645-817dc4ee9272',
    73: '6f13d8af-08c7-41b7-84ca-1a2d1c589343',
    74: 'e5759bc2-5ca9-4fde-bda8-e35ff6215ab6',
    75: 'c80938c6-846a-4de3-9314-207f4abb0553',
    76: '81910b89-caee-437c-8994-d69eee6d1f0a',
    77: '8318cba2-4c22-4a4d-af5b-97e67272d8f6',
    78: 'eca147ed-51d2-42f1-82ab-c0054d98d771',
    79: '80b5b5ad-e385-4ac1-9fc6-4806e1d03827',
    80: 'f49797da-a594-4a37-add5-315dab293d62',
    81: '9a9e68ec-39ac-4284-8031-d7d5be480930',
    82: '5c43fd91-4f24-4d89-9b9b-ec61117efc65',
    83: '55670488-5eea-4d46-829f-652e164b42e0',
    84: 'de253451-2ac5-4371-b0eb-571ddd606c8f',
    85: '908f030c-b7c0-48e7-8702-74d8c97a732e',
    86: 'd730d4e7-d87a-4412-bcca-c49ac14e4cc7',
    87: '113506e8-821b-425c-8b53-e8062b89b263',
    88: '4feaa591-9075-4b6e-a6e6-fa18398ffe47',
    89: 'cb816d3d-ce5e-4f4b-8384-f92cdd80c60e',
    90: '93f257c3-52aa-4ffb-ad88-968070ee9561'
};
